module.exports = __webpack_public_path__ + "img/iot5.1e51c19b.png";